// src/components/BlogPostViewer.tsx
import React from 'react';
import DOMPurify from 'dompurify';
import { BlogPost } from '../types/blog';
import { useBlogPost } from '../hooks/useBlogPost';

interface BlogPostViewerProps {
  blogPost: BlogPost;
  className?: string;
  onSEODataExtracted?: (seoData: any) => void;
}

const BlogPostViewer: React.FC<BlogPostViewerProps> = ({ 
  blogPost, 
  className = '',
  onSEODataExtracted
}) => {
  const { post, loading, error, seoData } = useBlogPost(blogPost);

  // Pass SEO data to parent component when available
  React.useEffect(() => {
    if (seoData && onSEODataExtracted) {
      onSEODataExtracted(seoData);
    }
  }, [seoData, onSEODataExtracted]);

  if (loading) {
    return (
      <div className={`blog-post-viewer ${className}`}>
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded mb-4"></div>
          <div className="h-4 bg-gray-200 rounded mb-2"></div>
          <div className="h-4 bg-gray-200 rounded mb-2"></div>
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`blog-post-viewer error ${className}`}>
        <div className="bg-red-50 border border-red-200 rounded p-4">
          <h3 className="text-red-800 font-semibold">Error Loading Post</h3>
          <p className="text-red-600">{error}</p>
        </div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className={`blog-post-viewer ${className}`}>
        <div>No post found</div>
      </div>
    );
  }

  return (
    <article className={`blog-post-viewer ${className}`}>
      <header className="blog-post-header mb-6 mt-24">
        {/* <h1 className="text-3xl font-bold mb-2">{post.title}</h1> */}
        {/* <div className="text-gray-600 mb-2">
          {/* <time dateTime={post.date}> */}
            {/* {new Date(post.date).toLocaleDateString()} */}
          {/* </time> */}
          {/* <span className="mx-2">•</span> */}
          {/* <span className="capitalize">
            {post.category.replace('-', ' ')}
          </span> }
        </div> */}
        {/* {post.tags && (
          <div className="flex flex-wrap gap-2">
            {/* {post.tags.map(tag => (
              <span 
                key={tag}
                className="bg-blue-100 text-blue-800 text-sm px-2 py-1 rounded"
              >
                {tag}
              </span>
            ))} }
          </div>
        )} */}
      </header>
      
      <div 
        className="blog-post-content"
        dangerouslySetInnerHTML={{ 
          __html: post.content
        }}
      />
    </article>
  );
};

export default BlogPostViewer;